import { Observable } from 'rxjs';
import { AjaxObservable } from 'rxjs/internal-compatibility';
import { AjaxResponse } from 'rxjs/ajax';
import { map } from 'rxjs/operators';

const mapResponse = map((x: AjaxResponse) => x.response);

export function ajaxPost(
  url: string,
  body?: any,
  headers?: Object,
  method: string = 'POST',
): Observable<any> {
  return new AjaxObservable<AjaxResponse>({ url, body, headers, method });
}

export const ajaxGetJSON = <T>(
  url: string,
  headers?: Object,
): Observable<T> => {
  return mapResponse(
    new AjaxObservable<AjaxResponse>({
      headers,
      url,
      method: 'GET',
      responseType: 'json',
    }),
  );
};
